import consts from "@/consts.js";
import Request from './request';


async function fetchByShop(data) {// 获取某门店下多地址
    return Request('get', "api/shop-address/view-by-shop/" , data);
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/shop-address/" + id);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/shop-address", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    // data.fieldFilter = ["id", "shop_code", "shop_name","status"]; //仅筛选少许必要字段
    return Request('get', "api/shop-address/select", data, false, false, true);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/shop-address/edit?id=" + id, data);
    } else {
        return Request('post', "api/shop-address/add", data);
    }
}

async function del(id) {// 删除数据
    return Request('delete', "api/shop-address/delete/" + id);
}

async function syncAddress(data) {// 同步门店默认地址
    return Request('post', "api/shop-address/sync-address", data);
}

export default {
    fetchByShop,
    fetchOne,
    fetchAll,
    fetchAllForSelect,
    save,
    del,
    syncAddress,
};